import React, { lazy } from 'react';

const Icons = {
    call: React.lazy(() => import('../assets/icons/Call24Px.js')),
    chat: React.lazy(() => import('../assets/icons/Chat24Px.js')),
    chat_bubble_outline: React.lazy(() => import('../assets/icons/ChatBubbleOutline24Px.js')),
    checklist: React.lazy(() => import('../assets/icons/Checklist24Px.js')),
    conversation: React.lazy(() => import('../assets/icons/Conversation24Px.js')),
    crop_original: React.lazy(() => import('../assets/icons/CropOriginal24Px.js')),
    date_range: React.lazy(() => import('../assets/icons/DateRange24Px.js')),
    location_on: React.lazy(() => import('../assets/icons/LocationOn24Px.js')),
    mail_outline: React.lazy(() => import('../assets/icons/MailOutline24Px.js')),
    mode_edit: React.lazy(() => import('../assets/icons/ModeEdit24Px.js')),
    payment: React.lazy(() => import('../assets/icons/Payment24Px.js')),
    perm_phone_msg: React.lazy(() => import('../assets/icons/PermPhoneMsg24Px.js')),
    phone: React.lazy(() => import('../assets/icons/Phone24Px.js')),
    play_circle_outline: React.lazy(() => import('../assets/icons/PlayCircleOutline24Px.js')),
    restaurant: React.lazy(() => import('../assets/icons/Restaurant24Px.js')),
    schedule: React.lazy(() => import('../assets/icons/Schedule24Px.js')),
    search: React.lazy(() => import('../assets/icons/Search24Px.js')),
    shopping_basket: React.lazy(() => import('../assets/icons/ShoppingBasket24Px.js')),
    smartphone: React.lazy(() => import('../assets/icons/Smartphone24Px.js')),
    stars: React.lazy(() => import('../assets/icons/Stars24Px.js')),
    stay_current: React.lazy(() => import('../assets/icons/StayCurrentPortrait24Px.js')),
    store: React.lazy(() => import('../assets/icons/Store24Px.js')),
    task_alt: React.lazy(() => import('../assets/icons/TaskAlt24Px.js')),
};

export default Icons;
